<script setup lang="ts">
import { appScrollTo, getAppScrollTop } from '@/utils/appScroller'

/*
 * ⚠️ NOT `useWindowScroll()`. On a phone the window is pinned at 0 and `main.mobile-shell__content`
 * scrolls (`mobile-shell.scss`), and that element comes and goes with the breakpoint. Scroll events
 * do not bubble, but they do pass the document in the CAPTURE phase — so one capturing listener
 * hears whichever scroller is live without having to track it.
 */
const y = ref(0)

function syncScroll() {
  y.value = getAppScrollTop()
}

useEventListener(document, 'scroll', syncScroll, { capture: true, passive: true })

const scrollToTop = () => {
  appScrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
</script>

<template>
  <VScaleTransition
    style="transform-origin: center;"
    class="scroll-to-top d-print-none"
  >
    <VBtn
      v-show="y > 200"
      icon
      density="comfortable"
      @click="scrollToTop"
    >
      <VIcon
        size="22"
        icon="tabler-arrow-up"
      />
    </VBtn>
  </VScaleTransition>
</template>

<style lang="scss">
.scroll-to-top {
  position: fixed !important;

  // To keep button on top of v-layout. E.g. Email app
  z-index: 999;
  inset-block-end: 5%;
  inset-inline-end: 25px;
}

// It tracks the PAGE scroller, so it means nothing over a dialog — and on a phone it sat on top
// of fullscreen sheets, covering their Close button. A dialog attached inside the POS frame
// stacks below z-index 999, so this cannot be solved by z-index alone.
body:has(.v-dialog.v-overlay--active) .scroll-to-top {
  display: none !important;
}
</style>
